import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'ebeihilfe-jpg-file-svg',
  templateUrl: './jpg-file-svg.component.svg',
  encapsulation: ViewEncapsulation.None,
  standalone: true,
})
export class JpgFileSvgComponent {}
